import React from "react";
import PropTypes from "prop-types";
import AddBuildingRow from "./AddBuildingRow";
import EditBuildingRow from "./EditBuildingRow";
import ViewBuildingRow from "./ViewBuildingRow";

const BuildingRow = (props) => {
  const { mode } = props;
  if (mode === "add") {
    return <AddBuildingRow {...props} />;
  } else if (mode === "edit") {
    return <EditBuildingRow {...props} />;
  } else {
    return <ViewBuildingRow {...props} />;
  }
};

BuildingRow.propTypes = {
  mode: PropTypes.oneOf(["add", "edit", "view"]).isRequired,
  building: PropTypes.object,
  index: PropTypes.number,
  selectedBuilding: PropTypes.object,
  onRowClick: PropTypes.func,
  buildingOptions: PropTypes.array,
  addBuilding: PropTypes.func,
  handlers: PropTypes.object,
  //handleAutoSave: PropTypes.func,
  newBuildingId: PropTypes.string,
  setNewBuildingId: PropTypes.func,
};

export default BuildingRow;
